import React, { forwardRef } from 'react';
import { Box, TextField } from '@mui/material';
import { amountInWords } from '../utils/amountInWords';

const hasText = (text) => text !== undefined && text !== null && text !== false && String(text).trim() !== '';

// Shows a rupee amount in words under the input, e.g. "Twelve Lakh Fifty Thousand Rupees".
// Use it like a TextField; any helperText of its own is shown below the words.
// Pass `wordsFor` when the value to read out differs from `value`.
const AmountField = forwardRef(({ helperText, value, wordsFor, ...props }, ref) => {
  const words = amountInWords(wordsFor !== undefined ? wordsFor : value);
  const content = words ? (
    <>
      <Box component="span" sx={{ display: 'block', fontStyle: 'italic' }}>{words}</Box>
      {hasText(helperText) && <Box component="span" sx={{ display: 'block' }}>{helperText}</Box>}
    </>
  ) : helperText;
  return <TextField ref={ref} value={value} helperText={content} {...props} />;
});

AmountField.displayName = 'AmountField';

export default AmountField;
